import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {
  StructureConfig,
  StructureField,
  StructureRelation,
} from '@core/interfaces/bpc-structure-config';

@Component({
  name: 'bpc-entity-structure',
  components: {},
})
export default class EntityStructure extends Vue {
  @Prop(String) readonly entity: string;
  @Prop(String) readonly configPath: string;
  @Prop(Object) readonly configObject: StructureConfig;

  public config: StructureConfig;
  public loading = false;
  public showRelationFields = false;
  public selectedRelation: string = null;

  public get entityFormConfigPath(): string {
    const configEntity = this.entity.replace(/-/g, '_'); // TODO: Manage this in back (provisional)
    return this.configPath
      ? this.configPath
      : this.$bpcApiRouteHelper.getEntityStructureConfigPath(configEntity);
  }

  public get dbFields(): StructureField[] {
    if (this.config) {
      return Object.values(this.config.dbFields || {});
    } else {
      return [];
    }
  }

  public get computedFields(): StructureField[] {
    if (this.config) {
      return Object.values(this.config.computedFields || {});
    } else {
      return [];
    }
  }

  public get relations(): StructureRelation[] {
    if (this.config) {
      return Object.values(this.config.relations || {});
    } else {
      return [];
    }
  }

  public get selectedRelationConfig(): StructureRelation {
    if (this.config && this.selectedRelation) {
      return Object.values(this.config.relations || {}).find(
        rel => rel.entity_name === this.selectedRelation,
      );
    } else {
      return null;
    }
  }

  getEntityStructureConfig() {
    this.loading = true;
    this.$bpcApi.get(this.entityFormConfigPath).subscribe(res => {
      console.log('structure', res);
      this.config = res.data;
      this.openFirstRelation();
      this.loading = false;
    });
  }
  /* Lifecycle hooks */
  created() {
    if (!this.configObject) {
      this.getEntityStructureConfig();
    } else {
      this.loading = true;
      this.config = this.configObject;
      this.openFirstRelation();
      this.loading = false;
    }
  }

  openFirstRelation() {
    if (this.relations && this.relations[0]) {
      this.openRelationFields(this.relations[0]);
    }
  }

  openRelationFields(relation: StructureRelation) {
    this.showRelationFields =
      this.selectedRelation === relation.entity_name ? !this.showRelationFields : true;
    this.selectedRelation = relation.entity_name;
  }

  // mounted () { }
  // updated () { }
  // destroyed () { }
}
